import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import CoverPhotoContainer from './cover-photo-container';
import ProductCode from './product-code';
import Address from './address';
import Website from './website';
import Phone from './phone';
import Logo from './logo';
import Select from 'react-select';
import Icon from '../../tc-ui/icon';
import GenericTopBar from './top-banner';
import { search } from '../../../stores/partner-finder/partnerFinder-actions';
import { updateSuppProfileProps } from '../../../stores/profile/company/profile-actions';
import { RaisedButton, FontIcon } from 'material-ui';
import { equals, call, cond, always, T, merge, either, isNil, isEmpty, path, propOr, pathOr } from 'ramda';

const isNilOrEmpty = either(isNil, isEmpty);

class ProfileTopBar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      profileToShow,
      isViewingOwnProfile,
      routeName,
      isSingleLocSupplier,
      singleLocId,
      isEditable,
      user,
      updateProp,
    } = this.props;
    const showBackBanner = path(['location', 'state', 'from'], this.props);
    const backBannerText = path(['location', 'state', 'text'], this.props);
    const viewingAsObj = call(cond([
      [equals('profile'), always({ companyId: profileToShow.companyId })],
      [equals('location'), always({ locationId: profileToShow.locationId })],
      [equals('product'), always({ productId: profileToShow.productId })],
      [T, always({})],
    ]), routeName);

    return (
      <div style={{ maxWidth: '1232px', margin: '0 auto', padding: '0 16px 0 16px' }} id="topSuppEl">
        <div style={{ marginTop: isViewingOwnProfile ? '65px' : '' }}>
          {
            isViewingOwnProfile ?
              <GenericTopBar
                numberOfIcons={0}
                bannerColor="#00bcd4"
                bannerHeight="50px"
                bannerContent={
                  <div className="Grid" style={{ color: '#ffffff', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ display: 'inline-block', marginRight: '20px' }}>
                      <Icon
                        className="tc-icon-cancel"
                        onClick={() => {
                          updateProp(merge(viewingAsObj, { viewingAs: 'unconnected', previewingOwnProfile: false }));
                          this.context.router.push('/profile');
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                    </span>
                    <span style={{ display: 'inline-block', marginRight: '10px' }}>
                      This is what your profile looks like to {equals(profileToShow.viewingAs, 'unconnected') ? 'an' : 'a'}
                    </span>
                    <span style={{ display: 'inline-block' }}>
                      <Select
                        name="viewAs"
                        options={[
                          { value: 'connected', label: 'Connected' },
                          { value: 'unconnected', label: 'Unconnected' },
                        ]}
                        clearable={false}
                        style={{ width: '130px', textAlign: 'left' }}
                        value={profileToShow.viewingAs}
                        onChange={(value) => updateProp(merge(viewingAsObj, { viewingAs: value.value }))}
                      />
                    </span>
                    <span style={{ display: 'inline-block', marginLeft: '10px' }}> user.</span>
                  </div>
                }
              />
              : <span/>
          }
          {
            showBackBanner ?
              <div style={isViewingOwnProfile ? { borderTop: '1px solid #26c6da' } : { margin: `65px 0 -65px 0` }}>
                <GenericTopBar
                  numberOfIcons={0}
                  bannerColor="#00bcd4"
                  bannerHeight="50px"
                  bannerContent={
                    <div style={{ color: '#ffffff', textAlign: 'center' }}>
                      <FontIcon
                        className="tc-icon-arrow_back"
                        style={{ color: '#ffffff', cursor: 'pointer' }}
                        onTouchTap={this.context.router.goBack}
                      >
                        <span style={{ fontSize: '24px', fontWeight: '600', marginLeft: '10px', fontFamily: "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif" }}>
                          {backBannerText}
                        </span>
                      </FontIcon>
                    </div>
                  }
                />
              </div> : <span/>
          }
        </div>
        <CoverPhotoContainer
          isViewingOwnProfile={isViewingOwnProfile}
          isSingleLocSupplier={isSingleLocSupplier}
          {...this.props}
        />
        <div style={{ marginTop: isViewingOwnProfile ? '' : '64px' }} className="l-profile-tool-panel-container">
          <div style={{
            position: 'relative',
            height: '100%',
            maxWidth: '1232px',
            margin: 'auto',
          }}
          >
            <Logo {...this.props} />
            <div className="l-profile-tool-panel">
              <ProductCode {...this.props} />
              <Address {...this.props} />
              <Website {...this.props} />
              <Phone {...this.props} />
              <div>
                {
                  equals(routeName, 'profile') && equals(location.pathname.split('/').slice(1)[0], 'profile') ?
                    <div style={{ float: 'right', display: 'inline-block' }}>
                      <RaisedButton
                        label="Preview Profile As"
                        backgroundColor="#f5f5f5"
                        onTouchTap={() => {
                          const hash = `#topSuppEl`;
                          const element = document.querySelector(hash);
                          if (element) scrollTo(hash, { offset: -70 });
                          updateProp({ previewingOwnProfile: true });
                          this.context.router.push(isSingleLocSupplier ? `/locations/${singleLocId}` : `/company/${profileToShow.companyId}`);
                          window.dataLayer.push({
                            event: 'TRACK_EVENT',
                            ev: {
                              category: 'Profile',
                              action: 'Clicks from preview profile as',
                            },
                          });
                        }}
                        style={{ height: '25px' }}
                      />
                    </div> : <span/>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProfileTopBar.propTypes = {
  user: PropTypes.object,
  profileToShow: PropTypes.object,
  history: PropTypes.object,
  partnerFinderReducer: PropTypes.object,
  updateProfileProp: PropTypes.func,
  isViewingOwnProfile: PropTypes.bool,
  routeName: PropTypes.string,
  isSingleLocSupplier: PropTypes.bool,
  singleLocId: PropTypes.string,
  isEditable: PropTypes.bool,
  setPFPage: PropTypes.func,
  updateProp: PropTypes.func,
};

const mapStateToProps = ({ partnerFinder, user }) => ({
  partnerFinderReducer: partnerFinder.toJS(),
  user: user.toJS(),
});

const mapDispatchToProps = dispatch => ({
  setPFPage: (params, pagination) => dispatch(search(params, pagination)),
  updateProp: (...args) => dispatch(updateSuppProfileProps(...args)),
});
ProfileTopBar.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfileTopBar);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-top-bar/profile-top-bar-container.jsx